import React from "react"
import ReactDOM from "react-dom/client"

import reportWebVitals from "./reportWebVitals"
import App from "./app/app"
import "./styles/styles.css"

// Theme and styles
import "primereact/resources/themes/lara-light-indigo/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import "primeflex/primeflex.css"

//Si estas leyendo esto, es porque ya hice el push del proyecto con las minusculas

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
